module.exports = __webpack_public_path__ + "apple-touch-icon-60x60.png?f6906f8fe8fed911b4f5dace283156cf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-touch-icon-60x60.png
// module id = 143
// module chunks = 0